module.exports = __webpack_public_path__ + "static/media/gamesPlayed.84a35015.svg";